var bundleitemcnt = parseInt($('.byob-preview').attr('data-bundleitemcnt'));

$('.collection-byob-product-item').each(function () {
    var $productItem = $(this);
    var $checkbox = $productItem.find('.collection-byob-product-item-checkbox');

    if($productItem.find('.collectionByobProductJson').length > 0){
      // Get product JSON
      var productData = JSON.parse($productItem.find('.collectionByobProductJson').text()).product;
  
      // All swatch radios inside this product
      var $swatches = $productItem.find('.byob-product-item-block-swatch__radio, .byob-product-item-color-swatch__radio');
  
      // Update variant ID
      function updateSelectedVariantId() {
          var selectedOptions = [];
  
          // Loop through each product option index
          productData.options.forEach(function(option, index) {
              var optionPosition = index + 1;
  
              // Get checked radio for this option
              var $checkedSwatch = $productItem.find('[data-option-position="' + optionPosition + '"]:checked');
  
              if ($checkedSwatch.length) {
                  // 👉 USE THE INPUT VALUE DIRECTLY
                  selectedOptions.push($checkedSwatch.val().trim());
              }
          });
  
          // Match variant
          var matchedVariant = productData.variants.find(function (variant) {
              return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
          });
  
          if (matchedVariant) {
              $checkbox.attr('data-variant-id', matchedVariant.id);
              console.log("✔ Updated variant:", matchedVariant.id, productData.title);
          } else {
              console.log("❌ No matching variant for:", selectedOptions);
          }
      }
  
      // Run once
      updateSelectedVariantId();
  
      // Run on swatch change
      $swatches.on('change', function () {
          updateSelectedVariantId();
      });
    }

});

$(document).ready(function(){
    // BYOB START
    var addedcnt = 0;
    var bundle_price = 0;
    var bundle_compare_price = 0;

    // ⬇️ ADD THESE
    function byobStackCount(pid) {
      return $('.byob-preview_item:not(.is-blank)[data-pid="' + pid + '"]').length;
    }

    function byobFillSlot($btn) {
      const featuredImage = $btn.attr('data-featuredimage');
      $('.byob-preview_item.is-blank').first()
        .attr('data-vid', $btn.attr('data-variant-id'))
        .attr('data-pid', $btn.attr('data-product-id'))
        .attr('data-price', $btn.attr('data-product-price'))
        .attr('data-compare-price', $btn.attr('data-product-compare-price'))
        .removeClass('is-blank')
        .find('.byob-preview_item-media')
        .html(`<img src="${featuredImage}" loading="lazy" width="150" height="150" alt="">`);
    }

    function byobClearSlot($slot) {
      $slot.addClass('is-blank')
        .removeAttr('data-pid data-vid data-price data-compare-price')
        .find('.byob-preview_item-media')
        .html('<span>Select Item</span>');
    }

    function byobSyncCard(pid) {
      const count = byobStackCount(pid);
      $('.product-item[data-product-id="' + pid + '"]').each(function () {
        $(this).toggleClass('added', count > 0) // if you keep added on grid; else drop
          .toggleClass('in-stack', count > 0)
          .find('.byob-product-form__add-button').toggleClass('added', count > 0).end()
          .find('.byob-product-item__quantity--input').val(count);
      });
      // qv is variant-level, sync every open qv wrapper for a variant of this product
      $('.product-form__buy-buttons').each(function () {
        byobSyncQv($(this));
      });
    }

    function byobVariantCount(vid) {
      return $('.byob-preview_item:not(.is-blank)[data-vid="' + vid + '"]').length;
    }

    function byobCurrentVid($wrap) {
      const $form = $wrap.closest('.product-form').find('form[is="product-form"]');
      const formVid = $form.find('input[name="id"]').val();
      if (formVid) return formVid;
      return $wrap.find('.byob-product-form-qv__add-button').attr('data-variant-id');
    }

    function byobSyncQv($wrap) {
      const $btn = $wrap.find('.byob-product-form-qv__add-button').first();
      if (!$btn.length) return;

      const vid = byobCurrentVid($wrap);
      $btn.attr('data-variant-id', vid);
      const count = byobVariantCount(vid);

      $btn.toggleClass('added', count > 0)
        .closest('.product-form__buy-buttons')
        .toggleClass('in-stack', count > 0);

      const $input = $wrap.find('.byob-product-item__quantity--input');
      $input.each(function () {
        this.value = String(count > 0 ? count : 1);
        this.setAttribute('value', this.value);
      });

      $wrap.find('.byob-product-item__quantity--plus')
        .prop('disabled', addedcnt >= bundleitemcnt);

      const pid = $btn.attr('data-product-id');
      $('.product-item[data-product-id="' + pid + '"]')
        .toggleClass('in-stack', byobStackCount(pid) > 0);
    }

    function byobSyncQvWithVid($wrap, vid) {
      const $btn = $wrap.find('.byob-product-form-qv__add-button').first();
      if (!$btn.length) return;

      $btn.attr('data-variant-id', vid);
      const count = byobVariantCount(vid);

      $btn.toggleClass('added', count > 0)
        .closest('.product-form__buy-buttons')
        .toggleClass('in-stack', count > 0);

      const $input = $wrap.find('.byob-product-item__quantity--input');
      $input.each(function () {
        this.value = String(count > 0 ? count : 1);
        this.setAttribute('value', this.value);
      });

      $wrap.find('.byob-product-item__quantity--plus')
        .prop('disabled', addedcnt >= bundleitemcnt);

      const pid = $btn.attr('data-product-id');
      $('.product-item[data-product-id="' + pid + '"]')
        .toggleClass('in-stack', byobStackCount(pid) > 0);
    }
    
    
    // function disableAddedVariantButtons() {
    //   $('.byob-preview_item[data-vid]').each(function() {
    //     const id = $(this).attr('data-vid');
    //     $(`.byob-product-form__add-button[data-variant-id="${id}"]`).prop('disabled', true).addClass('added');
    //   });
    // }
    // Run once on page load
    // disableAddedVariantButtons();
    
    // Watch the entire body for any DOM changes
    const observer = new MutationObserver(() => {
      if(addedcnt == bundleitemcnt){
        $('.byob-product-item__cta-button').attr("disabled","disabled");
        $('.byob-product-form-qv__add-button').attr("disabled","disabled");
        $('.product-item__quick-buy-button').attr("disabled","disabled");
        $('.collection-byos-atc-button').attr("disabled","disabled");
        console.log('0000000000000000000')
      }
      // disableAddedVariantButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    function activecheck(addedcnt,bundle_price,bundle_compare_price){
      console.log('activecheck',addedcnt);
      var save_percentage = (100 - ((bundle_price * 100) / bundle_compare_price));
      
      $('.bundle-selection-count').html(addedcnt); 
      $('.byob-total-price').html(formatMoney(bundle_price, currencyFormat)); 
      $('.byob-total-compare-price').html(formatMoney(bundle_compare_price, currencyFormat)); 

      if(save_percentage > 0){
        $('.byob-save_percentage').show().html(`(${Math.round(save_percentage)}%)`);    
      }else{
        $('.byob-save_percentage').hide();    
      }
      
      // if(addedcnt == 0){
      //   $('.byob-preview_cart-prices').hide();
      // }else{
      //   $('.byob-preview_cart-prices').show();
      // }
    
      if(addedcnt == bundleitemcnt){
        $('.byob-preview').addClass('stack-full');
        $('.byob-atc_button').removeAttr("disabled");
    
        $('.byob-product-item__cta-button').attr("disabled","disabled");
        $('.byob-product-form-qv__add-button').attr("disabled","disabled");
    
        $('.product-item__quick-buy-button').attr("disabled","disabled");
        $('.collection-byos-atc-button').attr("disabled","disabled");

        $('.byob-preview_cart-prices_qty-show').show();
        $('.byob-preview_cart-prices_default-show').hide();
    
        $('.collection-promotinal-item_button').attr("disabled","disabled");
        $('.byob-product-item__quantity--plus').attr("disabled","disabled");
      }else{
        $('.byob-preview').removeClass('stack-full');
        $('.byob-atc_button').attr("disabled","disabled");
    
        $('.byob-product-item__cta-button').removeAttr("disabled");
        $('.byob-product-form-qv__add-button').removeAttr("disabled");
    
        $('.product-item__quick-buy-button').removeAttr("disabled");
        $('.collection-byos-atc-button').removeAttr("disabled");

        $('.byob-preview_cart-prices_qty-show').hide();
        $('.byob-preview_cart-prices_default-show').show();
    
        $('.collection-promotinal-item_button').removeAttr("disabled");
        $('.byob-product-item__quantity--plus').removeAttr("disabled"); 
      }
    }
    
    $('body').on('click','.byob-preview_item-remove_button', function(){
      addedcnt = addedcnt - 1;
      bundle_price = bundle_price - parseInt($(this).closest('.byob-preview_item').attr('data-price'));
      bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.byob-preview_item').attr('data-compare-price'));
      var pid = $(this).closest('.byob-preview_item').attr('data-pid');
      activecheck(addedcnt,bundle_price,bundle_compare_price); 
    
      $(`.product-item[data-product-id="${pid}"]`).find('.byob-product-form__add-button').removeAttr("disabled").removeClass('added');
      $(this).closest('.byob-preview_item').addClass('is-blank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').removeAttr('data-compare-price').find('.byob-preview_item-media').html('<span>Select Item</span>');
      byobSyncCard(pid);
    });
    $('body').on('click', '.byob-product-form__add-button', function(e){
      e.preventDefault();

      if (addedcnt >= bundleitemcnt) return;

      const $btn  = $(this);
      const $wrap = $btn.closest('.product-form__buy-buttons');

      if ($wrap.length) {
        $btn.attr('data-variant-id', byobCurrentVid($wrap)); // live variant, not stale attr
      }

      addedcnt += 1;
      bundle_price += parseInt($(this).attr('data-product-price'));
      bundle_compare_price += parseInt($(this).attr('data-product-compare-price'));
      activecheck(addedcnt,bundle_price,bundle_compare_price);   
    
      $(this).addClass('added');
      var featuredimage = $(this).attr('data-featuredimage');
      var itembox = `<img src="${featuredimage}" loading="lazy" width="150" height="150" alt="">`; 
      $('.byob-preview_item.is-blank').first().find('.byob-preview_item-media').html(itembox);
      $('.byob-preview_item.is-blank').first().attr('data-vid',$(this).attr('data-variant-id')).attr('data-pid',$(this).attr('data-product-id')).attr('data-price',$(this).attr('data-product-price')).attr('data-compare-price',$(this).attr('data-product-compare-price')).removeClass('is-blank');    
      if (addedcnt >= bundleitemcnt) {
        $('quick-buy-drawer,quick-buy-popover').removeAttr("open")
      }
      if ($wrap.length) {
        byobSyncQv($wrap);                          // quick view: variant-level
      } else {
        byobSyncCard($btn.attr('data-product-id')); // grid: product-level
      }
    });
    
    $('body').on('click', '.byob-product-item__quantity--plus', function (e) {
      e.preventDefault();
      if (addedcnt >= bundleitemcnt) return;

      const $wrap = $(this).closest('.product-form__buy-buttons');

      if ($wrap.length) {
        // ---- QUICK VIEW: variant-level ----
        const $btn = $wrap.find('.byob-product-form-qv__add-button').first();
        const vid = byobCurrentVid($wrap);
        $btn.attr('data-variant-id', vid); // ensure slot stores the selected variant

        addedcnt += 1;
        bundle_price += parseInt($btn.attr('data-product-price'));
        bundle_compare_price += parseInt($btn.attr('data-product-compare-price'));

        byobFillSlot($btn);
        activecheck(addedcnt, bundle_price, bundle_compare_price);
        byobSyncQv($wrap);

        if (addedcnt >= bundleitemcnt) {
          $('quick-buy-drawer,quick-buy-popover').removeAttr("open")
        }
      } else {
        // ---- GRID: product-level ----
        const $btn = $(this).closest('.product-item').find('.byob-product-form__add-button');
        const pid = $btn.attr('data-product-id');

        addedcnt += 1;
        bundle_price += parseInt($btn.attr('data-product-price'));
        bundle_compare_price += parseInt($btn.attr('data-product-compare-price'));

        byobFillSlot($btn);
        activecheck(addedcnt, bundle_price, bundle_compare_price);
        byobSyncCard(pid);
      }
    });

    $('body').on('click', '.byob-product-item__quantity--minus', function (e) {
      e.preventDefault();

      const $wrap = $(this).closest('.product-form__buy-buttons');
      let $slot;
      let gridPid;   // ⬅️ add

      if ($wrap.length) {
        const vid = byobCurrentVid($wrap);
        $slot = $('.byob-preview_item:not(.is-blank)[data-vid="' + vid + '"]').last();
      } else {
        gridPid = $(this).closest('.product-item').attr('data-product-id');  // ⬅️ capture
        $slot = $('.byob-preview_item:not(.is-blank)[data-pid="' + gridPid + '"]').last();
      }

      if (!$slot.length) return;

      addedcnt -= 1;
      bundle_price -= parseInt($slot.attr('data-price'));
      bundle_compare_price -= parseInt($slot.attr('data-compare-price'));

      byobClearSlot($slot);
      activecheck(addedcnt, bundle_price, bundle_compare_price);

      if ($wrap.length) {
        byobSyncQv($wrap);
      } else {
        byobSyncCard(gridPid);   // ⬅️ use captured pid, not the cleared slot
      }
    });


    $('body').on('click','.byob-atc_button ', function(){
      $(this).attr("aria-busy",true);
      var items = [];
      var randomId = Math.random().toString(36).substring(2, 12);
      $(this).closest('.byob-preview_main').find('.byob-preview_item:not(.is-blank)').each(function(i,v){
        var val = $(this).attr('data-vid');         
         items.push({
          quantity: 1,
          id: val,
          properties: {
              '_personalize': 'main',
              '_type': 'byob',
              '_bundleid': randomId,
              '_item_count': bundleitemcnt
            }
        });   
      });    
      
      var data = {items};
      console.log('data',data)
      // var data = theme.utils.serialize(this.form);
     
      fetch('/cart/add.js', {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.json())
      .then(function(data) {      
        $.getJSON("/cart.js", function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: { cart }
          })); 
        });
        document.getElementById('mini-cart').open = true;
        $(this).removeAttr("aria-busy");
      }.bind(this));  
      
    });
    
    $('body').on('click', '.collection-promotinal-item_stack-full-button', function(e){
      $('.stack-full-modal-opener-error').text('Please remove one product from stack to open bundle');
      $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => {
          $('.stack-full-modal-opener-error').removeClass('show');
        }, 2000);
    });
    
    $('body').on('click', '.collection-byob-atc-button', function(e){
      var unfill_stack_count = $('.byob-preview_item.is-blank').length;
      var checkedCount = $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').length;
      console.log('000000000',unfill_stack_count,checkedCount);
      if(checkedCount == 0) {
        $('.stack-full-modal-opener-error').text('Please select atleast one item!');
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      } else if(unfill_stack_count == 0){
        $('.stack-full-modal-opener-error').text('You have added all three items for Stack. Remove an item to add a new one!');
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      } else if(checkedCount > unfill_stack_count){
        $('.stack-full-modal-opener-error').text(`You selected more item. please select ${unfill_stack_count} item to add!`);
        $('.stack-full-modal-opener-error').addClass('show');
        setTimeout(() => { $('.stack-full-modal-opener-error').removeClass('show'); }, 2000);
      }else {
        $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').each(function() {
          addedcnt += 1;
          bundle_price += parseInt($(this).attr('data-product-price'));
          bundle_compare_price += parseInt($(this).attr('data-product-compare-price'));
          activecheck(addedcnt,bundle_price,bundle_compare_price);   
    
          var featuredimage = $(this).attr('data-featuredimage');
          var itembox = `<img src="${featuredimage}" loading="lazy" width="150" height="150" alt="">`; 
          $('.byob-preview_item.is-blank').first().find('.byob-preview_item-media').html(itembox);
          $('.byob-preview_item.is-blank').first().attr('data-vid',$(this).attr('data-variant-id')).attr('data-pid',$(this).attr('data-product-id')).attr('data-price',$(this).attr('data-product-price')).attr('data-compare-price',$(this).attr('data-product-compare-price')).removeClass('is-blank');    
          $('quick-buy-drawer,quick-buy-popover').removeAttr("open")  
        });
        $('modal-content').removeAttr("open");
      }
    });

    let byobQvObserver = null;
    document.addEventListener('openable-element:load:end', function (e) {
      const root = e.target;
      const $wrap = $(root).find('.product-form__buy-buttons').first();
      if (!$wrap.length) return;

      byobSyncQv($wrap);                          // sync when QV opens/reopens

      if (byobQvObserver) byobQvObserver.disconnect();
      byobQvObserver = new MutationObserver(function () {
        const $w = $(root).find('.product-form__buy-buttons').first();
        if ($w.length) byobSyncQv($w);
      });
      byobQvObserver.observe(root, { childList: true, subtree: true });
    }, true);
    
    // BYOB END
    
    // $('body').on('click', '.cart-payment-summary-title', function() {
    //  $('.cart-payment-summary').slideToggle();
    // });
    
    $('body').on('click', '.toggle-term-condition', function() {
      $(this).toggleClass('active');
        $(this).parents('.coupon_offer-item').find('.term-condition_wrapper').toggle();
        if ($(this).hasClass('active')) {
        $(this).text('-hide');
      } else {
        $(this).text('+more');
      }
    });
    
    $('body').on('click', '.cart-offer-coupon_header-coupon-opner', function() {
      $('.cart-cart-coupon_offer-overlay').addClass('show');
    });
    $('body').on('click', '.cart-cart-coupon_offer-popover-close', function() {
      $('.cart-cart-coupon_offer-overlay').removeClass('show');
    });
    // $(document).on('change', '.collection-byob-product-item-checkbox', function() {
    //   var unfill_stack_count = $('.byob-preview_item.is-blank').length;
    //   var checkedCount = $(this).closest('.collection-byob-modal').find('.collection-byob-product-item-checkbox:checked').length;
    //   console.log('Checked count:', checkedCount);
    //   if(checkedCount == 0 || checkedCount > unfill_stack_count) {
    //     $('.collection-byob-atc-button').attr("disabled","disabled");
    //   }
    //   if(checkedCount >= 1 || checkedCount <= unfill_stack_count) {
    //     $('.collection-byob-atc-button').removeAttr("disabled");
    //   }
    // });


    $('.start-selection_button').on('click', function (e) {
      e.preventDefault();
      const offset = window.matchMedia('(max-width: 767px)').matches ? 140 : 320; 
      $('html, body').animate({
        scrollTop: $('.product-list').offset().top-offset
      }, 600);
    });

});
